import style from "../style.module.scss";

interface HoldContainerProps {
  hasBag: boolean;
  hasContainer: boolean;
  value: {
    movementName: string;
    holdDistributions: any[];
  };
}

export const HoldContainer = ({
  hasBag,
  value,
  hasContainer
}: HoldContainerProps) => {
  return (
    <div className={style.container}>
      {/* Titre du mouvement */}
      <div className={style.container__header}>
        <span className={style.container__title}>
          {value.movementName}
        </span>

       
      </div>

      {/* Liste des cales */}
      <div className={style.container__holds}>
        {value?.holdDistributions?.map((item: any) => (
          <div
            className={style.container__hold}
            key={item.hold}
          >
            {/* Numéro de cale */}
            <div className={style.container__hold_header}>
              <span className={style.container__hold_number}>
                Cale n°{item.hold}
              </span>
            </div>

            {/* Informations */}
            <div className={style.container__stats}>
              <div className={style.container__stat}>
                <span className={style.container__label}>
                  Nombre prévu
                </span>

                <strong className={style.container__value}>
                  {item.plannedCount ?? "-"}
                </strong>
              </div>

              <div className={style.container__stat}>
                <span className={style.container__label}>
                  Nombre restant
                </span>

                <strong className={style.container__value}>
                  {item.remainingCount ?? "-"}
                </strong>
              </div>

              <div className={style.container__stat}>
                <span className={style.container__label}>
                  Nombre total
                </span>

                <strong className={style.container__value}>
                  {item.doneCount ?? "-"}
                </strong>
              </div>

              {hasContainer && (
                <>
                  <div className={style.container__stat}>
                    <span className={style.container__label}>
                      Nombre vide prevu
                    </span>

                    <strong className={style.container__value}>
                      {item.plannedEmptyContainerCount ?? "-"}
                    </strong>
                  </div>

                  <div className={style.container__stat}>
                    <span className={style.container__label}>
                      Nombre plein prevu
                    </span>

                    <strong className={style.container__value}>
                      {item.plannedFilledContainerCount ?? "-"}
                    </strong>
                  </div>

                  <div className={""}></div>
                </>
              )}

              {hasBag && (
                <>
                  <div className={style.container__stat}>
                    <span className={style.container__label}>
                      Tonnage prévu
                    </span>

                    <strong className={style.container__value}>
                      {item.plannedTonnage ?? "-"}
                      {item.plannedTonnage != null && " T"}
                    </strong>
                  </div>

                  <div className={style.container__stat}>
                    <span className={style.container__label}>
                      Tonnage restant
                    </span>

                    <strong className={style.container__value}>
                      {item.remainingTonnage ?? "-"}
                      {item.remainingTonnage != null && " T"}
                    </strong>
                  </div>

                  <div className={style.container__stat}>
                    <span className={style.container__label}>
                      Tonnage total
                    </span>

                    <strong className={style.container__value}>
                      {item.doneTonnage ?? "-"}
                      {item.doneTonnage != null && " T"}
                    </strong>
                  </div>
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};